import accountModule from '../app.js';

import {userProfileManager, configManager, cookieUtil, AddressFormatterFactory, AccountConfigManager} from '@nuskin/ns-common-account';

accountModule.service('addressFormatterFactory', function() {
    return AddressFormatterFactory;
});
accountModule.service('AccountConfigManager', function() {
    return AccountConfigManager;
});
accountModule.service('configManager', function() {
    return configManager;
});
accountModule.service('personalService',
    ['$http', '$q', '$window', 'addressFormatterFactory', 'configManager', 'AccountConfigManager',
        function($http, $q, $window, addressFormatterFactory, configManager, AccountConfigManager) {
            var accountConfigManager = AccountConfigManager.getConfig(configManager);
            var countryCode = accountConfigManager.site['countryCode'];
            var languageCode = accountConfigManager['languageCode'];
            var sapServiceEndPoint = accountConfigManager.site['legacyServer'];
            var awsServiceEndPoint = nuskin.configuration.awsUrl;
            var addressFormatter = addressFormatterFactory.getAddressFormatter(countryCode);
            var self = this;
            self.userId= '';
            this.$http = $http;
            var deferredGigya = $q.defer();
            var sapServicePersonalProfileUrl = '/customer/api/v1/person/';
            var languageListUrl = '/content/localization/countryandlanguagetranslation.service.{code}.json';
            var emailServiceUrl = '/esb-util/api/v1/message?eid={eid}&locale={locale}';
            var favoriteListPrefix = awsServiceEndPoint + '/favorites/v1/';

            this.setUserId = function(userid) {
                self.userId = userid;
            };

            this.retrieveFavoriteList = function() {
                var eid = this.getEidDetails();
                var accountId = this.getAccountInfo();
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': true,
                        'authorization': 'JWT ' + eid
                    }
                };

                var url = favoriteListPrefix + accountId + '?cntry=' + countryCode + '&eid=' + eid;
                return $http.get(url, config);
            };

            this.deleteFromFavoritesList = function(sku) {
                var eid = this.getEidDetails();
                var accountId = this.getAccountInfo();
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': false,
                        'authorization': 'JWT ' + eid
                    }
                };

                var url = favoriteListPrefix + accountId + '/' + sku + '?cntry=' + countryCode + '&eid=' + eid;
                return $http.delete(url, config);
            };

            this.scrollToTop = function(targetLocation) {
                var windowWidth = angular.element(window).width();
                var newLocation = null;
                if (windowWidth < 768) {
                    newLocation = targetLocation && angular.element(targetLocation) ? targetLocation : '#rightPanel';
                } else {
                    newLocation = '#rightPanel';
                }
                angular.element('html, body').animate({
                    scrollTop: angular.element(newLocation).offset().top
                }, 400);
            };


            this.setLoginPref=function(loginData) {
                var eid = this.getEidDetails();
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': true
                    }
                };

                var user = {
                    UID: loginData.UID
                };

                if (null != loginData.loginId && loginData.loginId != undefined) {
                    user.loginID = loginData.loginId;
                    user.oldLoginID = loginData.oldLoginId;
                }
                if (null != loginData.newPassword && loginData.newPassword != undefined
                && loginData.newPassword.length > 0) {
                    user.newPassword = loginData.newPassword;
                }
                user.changeBy = self.userId.toUpperCase();

                var defferedSetUserName = $q.defer();
                var url = sapServiceEndPoint + '/account-util/api/v1/person/' + self.userId.toUpperCase()
                + '/credentials?eid=' + eid;
                $http.put(url, user, config ).then(function(response) {
                    defferedSetUserName.resolve(response.data);
                });
                return defferedSetUserName.promise;
            };
            /* Service that Updates EmailID/Username in Gigya in Personal Contact details Page*/
            this.updateUsernameInGigya=function(loginData) {
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var user = {
                    loginId: loginData.loginId,
                    oldLoginId: loginData.oldLoginId,
                    UID: loginData.UID
                };

                var defferedUpdateUserName = $q.defer();
                $http.post($window.location.protocol+'//'+$window.location.host+'/mecommerce/signup/user/setusername',
                    user, config ).then(function(response) {
                    defferedUpdateUserName.resolve(response);
                });
                return defferedUpdateUserName.promise;
            };
            this.getEidDetails = function() {
                var eid = cookieUtil.getCookie('USER_PROFILE_JWT');
                if (null != eid && eid != undefined) {
                    eid = JSON.parse(eid);
                }
                return eid;
            };

            this.getAccountInfo = function() {
                var hostAccountId = '';
                if (userProfileManager != null) {
                    var userProfileBusinessInfo = userProfileManager.getUserProfileMasterInfo();
                    if (userProfileBusinessInfo != null) {
                        hostAccountId = userProfileBusinessInfo.accountId;
                    }
                }
                return hostAccountId;
            };

            this.loadDetails = function() {
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var deferred = $q.defer();
                var url = sapServiceEndPoint + sapServicePersonalProfileUrl + self.userId.toUpperCase()
                + '?includeSponsor=true&includeInviter=true';
                $http.get(url, config).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            };

            this.setContactDetails = function(data) {
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var dataContact = {};
                if (data.contact && data.contact.mobilePhoneInput) {
                    dataContact = {
                        phoneNumbers: {
                            mobile: {
                                country: data.contact.mobilePhoneCode,
                                value: data.contact.mobilePhoneInput
                            }
                        },
                        email: data.contact.email
                    };
                } else {
                    dataContact.email = data.contact.email;
                }
                // set address updates if there are any
                if (data.address) {
                    var formattedAddress = addressFormatter.formatToService(data.address);
                    dataContact.addresses = {
                        local: formattedAddress
                    };
                }
                dataContact.changeBy = self.userId.toUpperCase();
                var url = sapServiceEndPoint + sapServicePersonalProfileUrl + self.userId.toUpperCase();
                return $http.put(url, dataContact, config);
            };

            this.setPersonalDetails = function(personalDetails) {
                var config = {
                    headers: {
                        'content-type': 'application/json',
                        'showgloballoader': true
                    }
                };

                var requestData = {
                    'gender': personalDetails.gender,
                    'birthDate': personalDetails.birthdate
                };
                requestData.changeBy = self.userId.toUpperCase();

                var deferred = $q.defer();
                var url = sapServiceEndPoint + sapServicePersonalProfileUrl + self.userId.toUpperCase()
                + '?includeSponsor=true&includeInviter=true';
                $http.put(url, requestData, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };

            this.setHeaderInfoGigya=function(data) {
                var params = {
                    profile: {
                        firstName: data.firstname,
                        lastName: data.lastname
                    },
                    callback: function(response) {
                        deferredGigya.resolve(response.status);
                    }
                };
                gigya.accounts.setAccountInfo(params);

                return deferredGigya.promise;
            };

            this.setHeaderInfoHybris=function(data) {
                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                // TODO include profile picture in request
                var user = {
                    'names': {
                        'local': {
                            'given': data.firstname,
                            'family': data.lastname
                        }
                    },
                    'preferredName': data.preferredname,
                    'profileImageUrl': data.profilePictureUrl,
                    'profileThumbnailUrl': data.profileImage
                };

                user.changeBy = self.userId.toUpperCase();
                var url = sapServiceEndPoint + sapServicePersonalProfileUrl + self.userId.toUpperCase();

                $http.put(url, user, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };

            this.loadStateDetails = function() {
                var deferred = $q.defer();
                var listUrl = '';
                if (countryCode == 'US') {
                    listUrl = '/etc/clientlibs/mecommerce/signup/account-settings-personal/json/statelist.json';
                } else if (countryCode == 'CA') {
                    listUrl = '/etc/clientlibs/mecommerce/signup/account-settings-personal/json/provincelist.json';
                }
                $http.get(listUrl).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            };

            this.getLanguageList = function() {
                var deferred = $q.defer();
                $http.get('/etc/clientlibs/mecommerce/signup/account-settings-personal/json/languagelist.json')
                    .then(function(response) {
                        deferred.resolve(response.data);
                    });
                return deferred.promise;
            };

            this.updateMember = function(memberInfo, invitationType) {
                var contactType = '';
                if (memberInfo.credentials.userEmailField != ''
                && memberInfo.credentials.userEmailField != null
                && memberInfo.credentials.userEmailField != undefined) {
                    contactType = 'email';
                    memberInfo.mobilephone='';
                } else {
                    contactType = 'phone';
                    memberInfo.credentials.userEmailField='';
                }

                var userProfileDetailInfo = userProfileManager.getUserProfileDetailInfo();
                var userProfileBusinessInfo = userProfileManager.getUserProfileMasterInfo();

                var deferred = $q.defer();

                // this is dummy request for demo purpose
                var user ={
                    'contactPreference': contactType,
                    'guestAccountId': userProfileBusinessInfo.accountId,
                    'guestEmail': memberInfo.credentials.userEmailField,
                    'guestFirstName': memberInfo.firstname,
                    'guestLastName': memberInfo.lastname,
                    'guestPhone': (memberInfo.mobilephone).toString(),
                    'hostAccountId': userProfileBusinessInfo.accountId,
                    'hostFirstName': userProfileDetailInfo.profileHeader.firstName,
                    'hostLastName': userProfileDetailInfo.profileHeader.lastName,
                    'hostProfilePhotoUrl': userProfileDetailInfo.profileHeader.profileThumbnailUrl,
                    'hostType': userProfileBusinessInfo.userType,
                    'hostUid': userProfileBusinessInfo.userId,
                    'hostEmail': userProfileDetailInfo.profileContactInfo.email,
                    'invitationStatus': 'ACCOUNT PENDING',
                    'invitationType': invitationType
                };

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var postUrl = mulesoftStorefrontEndpoint+'account/';
                $http.post(postUrl, user, config).then(function(data) {
                    deferred.resolve(data);
                });

                return deferred.promise;
            };

            this.getMember = function(distAcctId, uId) {
                var deferred = $q.defer();

                var getUrl = mulesoftStorefrontEndpoint+'accounts/'
                + distAcctId+'/hostuid/'+uId;
                $http.get(getUrl).then(function(data) {
                    deferred.resolve(data);
                });

                return deferred.promise;
            };

            this.validateMember = function(member) {
                var deferred = $q.defer();
                var user = {};

                if (member.credentials.userEmailField == '') {
                    user = {
                        'phone': member.mobilephone
                    };
                } else {
                    user = {
                        'email': member.credentials.userEmailField
                    };
                }
                // This is a dummy request
                var postUrl = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/balias@balias.com/searchDistributor';
                $http.post(postUrl, user).then(function(data) {
                    deferred.resolve(data);
                });

                return deferred.promise;
            };

            var getBase64 = function(file) {
                var deferred = $q.defer();
                var reader = new FileReader();
                var isFile = typeof file.name == 'string';
                if (isFile) {
                    reader.readAsDataURL(file);

                    reader.onload = function(e) {
                        deferred.resolve(reader.result);
                    };
                    reader.onerror = function(error) {

                    };
                } else {
                    deferred.resolve(file);
                }
                return deferred.promise;
            };

            this.uploadPhoto = function(files) {
                var deferred = $q.defer();
                var promise = null;
                promise = getBase64(files[0]);

                promise.then(function(file) {
                    deferred.resolve(file);
                });

                return deferred.promise;
            };

            this.uploadPhotoToGigya = function(file) {
                var deferred = $q.defer();
                var fileData = file.substr(file.indexOf(',')+1);
                var params = {
                    photoBytes: fileData,
                    publish: 'true',
                    callback: function(response) {
                        deferred.resolve(response);
                    }
                };
                gigya.accounts.setProfilePhoto(params);
                return deferred.promise;
            };

            this.saveCommunication = function(data, contactPreferenceText) {
                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var dataCommunicationPreference = {
                    'preferredLanguage': data.languagepref,
                    'preferences': {
                        'acceptMarketingEmail': data.emailIsOpted,
                        'acceptMarketingSMS': data.textIsOpted,
                        'contactPreference': data.emailIsOpted ? contactPreferenceText.toUpperCase() : undefined
                    }
                };

                dataCommunicationPreference.changeBy = self.userId.toUpperCase();
                var url = sapServiceEndPoint + sapServicePersonalProfileUrl + self.userId.toUpperCase();

                $http.put(url, dataCommunicationPreference, config )
                    .success(function(data) {
                        deferred.resolve(200);
                    }).error(function() {
                        deferred.resolve(404);
                    });
                return deferred.promise;
            };

            this.savePrivacyPref = function(data) {
                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var user = {
                    'preferences': {
                        'showContactInfo': data.showContactInfoChecked,
                        'showContactInfoToFirstUpLine': data.showContactInfoToUplineChecked,
                        'showContactInfoToFamilyAndFriends': data.showContactInfoToFamilyChecked,
                        'visibleInSponsorSearch': data.visibleInSponsorSearchChecked,
                        'visibleInScannerLocator': data.visibleInScannerLocatorChecked
                    }
                };

                user.changeBy = self.userId.toUpperCase();

                var url = sapServiceEndPoint + sapServicePersonalProfileUrl + self.userId.toUpperCase();

                $http.put(url, user, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };

            this.saveDeleteFamily = function(deleteFamilyList) {
                deleteFamilyList.forEach(function(item) {
                    var config = {
                        headers: {
                            'Content-Type': 'application/json',
                            'showgloballoader': true
                        }
                    };
                    if (item.hasOwnProperty('contactpreference')) {
                        var postUrl = mulesoftStorefrontEndpoint+'account/delete/'+item.invitationGuId;
                        $http.post(postUrl, config).then(function(data) {

                        });
                    } else {
                        var user = {memberId: item.userId};
                        user = JSON.stringify(user);
                        var headers = {
                            'Content-Type': 'application/json'
                        };
                        var endPointurl = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/'+self.userId;

                        $http({method: 'DELETE', data: user, url: endPointurl, headers: headers}).then(function(response) {
                            if (response.status='200') {
                                deActivateFamilyUser(item.gigyaId);
                            }
                        });
                    }
                });
            };


            var deActivateFamilyUser = function(gigyaId) {
                var config = {
                    headers: {
                        'content-type': 'application/json'
                    }
                };
                var reqData = {
                    UID: gigyaId
                };

                var defferedDeatcivateUser = $q.defer();
                $http.post($window.location.protocol+'//'+$window.location.host+'/mecommerce/signup/deactivate',
                    reqData, config ).then(function(response) {
                    defferedDeatcivateUser.resolve(response.data);
                });
                return defferedDeatcivateUser.promise;
            };


            this.addBillingInformation = function(data) {
                var expiryMonth;
                var expiryYear;
                if (data.cardexpiry) {
                    data.cardexpiry = data.cardexpiry.substr(0, 2) + '/' + data.cardexpiry.substr(data.cardexpiry.length-2);
                    var monthYear = data.cardexpiry.split('/');

                    expiryMonth = monthYear[0];
                    expiryYear = '20'+monthYear[1];
                }
                var saved = true;
                if (data.isprimary != true) {
                    data.isprimary = false;
                    saved = false;
                }

                var expdate = new Date(expiryYear, expiryMonth, 1);
                if (expdate < new Date()) {
                    data.isexpired = true;
                } else {
                    data.isexpired = false;
                }


                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var user = {
                    'accountHolderName': data.nameoncard,
                    'cardNumber': data.cardnumber,
                    'saved': saved,
                    'cardType': {
                        'code': data.cardtype.toLowerCase()
                    },
                    'expiryMonth': expiryMonth,
                    'expiryYear': expiryYear,
                    'defaultPayment': data.isprimary,
                    'billingAddress': {
                        'titleCode': data.titleCode,
                        'firstName': data.firstname,
                        'lastName': data.lastname,
                        'line1': data.streetAddress,
                        'line2': data.streetAddress2,
                        'town': data.city,
                        'postalCode': data.zipcode,
                        'contactAddress': 'false',
                        'shippingAddress': 'false',
                        'billingAddress': 'true',
                        'defaultAddress': data.isprimary,
                        'country': {
                            'isocode': 'US'
                        },
                        'region': {
                            'isocode': 'US-'+data.state
                        }

                    }
                };

                var url = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/'+self.userId+'/paymentdetails';

                $http.post(url, user, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };

            this.updateBillingInformation = function(data) {
                var expiryMonth;
                var expiryYear;
                if (data.cardexpiry) {
                    var monthYear = data.expiryDisplay.split('/');
                    expiryMonth = monthYear[0];
                    expiryYear = '20'+monthYear[1];
                }

                var saved = true;
                if (data.isprimary != true) {
                    data.isprimary = false;
                    saved = false;
                }

                var expdate = new Date(expiryYear, expiryMonth, 1);
                if (expdate < new Date()) {
                    data.isexpired = true;
                } else {
                    data.isexpired = false;
                }

                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var user = {
                    'accountHolderName': data.nameoncard,
                    'cardNumber': data.cardnumber,
                    'saved': saved,
                    'cardType': {
                        'code': data.cardtype.toLowerCase()
                    },
                    'expiryMonth': expiryMonth,
                    'expiryYear': expiryYear,
                    'defaultPayment': data.isprimary,
                    'billingAddress': {
                        'titleCode': data.titleCode,
                        'firstName': data.firstname,
                        'lastName': data.lastname,
                        'line1': data.streetAddress,
                        'line2': data.streetAddress2,
                        'town': data.city,
                        'postalCode': data.zipcode,
                        'contactAddress': 'false',
                        'shippingAddress': 'false',
                        'billingAddress': 'true',
                        'defaultAddress': data.isprimary,
                        'country': {
                            'isocode': 'US'
                        },
                        'region': {
                            'isocode': 'US-'+data.state
                        }

                    }
                };

                var url = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/'+self.userId+'/paymentdetails/'+data.id;

                $http.patch(url, user, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };

            this.addShippingAddress = function(data) {
                if (data.isprimary != true) {
                    data.isprimary = false;
                }

                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var user = {
                    'titleCode': data.titleCode,
                    'firstName': data.firstname,
                    'lastName': data.lastname,
                    'line1': data.streetAddress,
                    'line2': data.streetAddress2,
                    'town': data.city,
                    'postalCode': data.zipcode,
                    'contactAddress': 'false',
                    'shippingAddress': 'true',
                    'billingAddress': 'false',
                    'defaultAddress': data.isprimary,
                    'country': {
                        'isocode': 'US'
                    },
                    'region': {
                        'isocode': 'US-'+data.state
                    }
                };

                var url = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/'+self.userId+'/addresses';

                $http.post(url, user, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };
            this.updateShippingAddress = function(data) {
                if (data.isprimary != true) {
                    data.isprimary = false;
                }

                var deferred = $q.defer();

                var config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'showgloballoader': true
                    }
                };
                var user = {
                    'titleCode': data.titleCode,
                    'firstName': data.firstname,
                    'lastName': data.lastname,
                    'line1': data.streetAddress,
                    'line2': data.streetAddress2,
                    'town': data.city,
                    'postalCode': data.zipcode,
                    'contactAddress': 'false',
                    'shippingAddress': 'true',
                    'billingAddress': 'false',
                    'defaultAddress': data.isprimary,
                    'country': {
                        'isocode': 'US'
                    },
                    'region': {
                        'isocode': 'US-'+data.state
                    }
                };

                var url = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/'+self.userId+'/addresses/'+data.id;

                $http.patch(url, user, config).then(function(response) {
                    deferred.resolve(response.status);
                });
                return deferred.promise;
            };

            this.getMbsStory = function() {
                var userId;
                var mbsdeferred = $q.defer();
                if (userProfileManager.isUserLoggedIn()) {
                    userId = userProfileManager.getUserProfileMasterInfo().userId;
                    var getUrl =mulesoftStorefrontEndpoint+'userbrandstory/'+userId;
                    $http.get(getUrl).then(function(response) {
                        mbsdeferred.resolve(response);
                    });
                } else {

                }

                return mbsdeferred.promise;
            };

            this.sendEmailInvite = function(emailAddress, guid, templatePath, userId, model) {
                var userProfile = userProfileManager.getUserProfileDetailInfo();

                var requestData = {
                    'fromEmail': '',
                    'toEmailCSV': emailAddress,
                    'ccEmailCSV': '',
                    'bccEmailCSV': '',
                    'accountCustomerID': 'no',
                    'toCustomerCSV': '',
                    'ccCustomerCSV': '',
                    'bccCustomerCSV': '',
                    'notificationType': 'Email',
                    'customerID': userId,
                    'templateURL': templatePath,
                    'body': '',
                    'subject': '',
                    'fromMobileNumber': '',
                    'toMobileNumber': '',
                    'smsText': '',
                    'orderID': '',
                    'replacementVariableCSV': 'guid::'+guid+',firstName::'+model.firstname+',lastName::'
                + model.lastname+',accountholder::' + userProfile.profileHeader.firstName
                };

                var url = mulesoftHybrisEndpoint+'v2/nuskin_'+countryCode+'/users/'+userId+'/sendMecEmail';
                var deferred = $q.defer();
                $http.post(url, requestData).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            };

            this.getInvitationId = function() {
                var userProfileBusinessInfo = userProfileManager.getUserProfileMasterInfo();
                var hostAccountId = userProfileBusinessInfo.accountId;
                var hostUserId = userProfileBusinessInfo.userId;

                var url = mulesoftStorefrontEndpoint+'accounts/'+hostAccountId+'/hostuid/'+hostUserId;

                var config = {
                    headers: {
                        'content-type': 'application/json',
                    }
                };
                var deferred = $q.defer();
                $http.get(url, config).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            };

            this.getLanguageListFromLocale = function(country) {
                var deffered = $q.defer();
                var aUrl = languageListUrl;
                aUrl = aUrl.replace('{code}', languageCode);

                $http.get(aUrl).then(function(response) {
                    var result = Object.values(response.data[country]);
                    var languages = Object.entries(result[1]).map(([code, name]) => ({code, name}));
                    deffered.resolve(languages);
                });
                return deffered.promise;
            };

            this.isEmailVerified = function(data) {
                var isEmailVerified = true;
                if (data != null && data != undefined) {
                    var isVerified = data.isVerified;
                    var userCreatedTimestamp = data.createdTimestamp;
                    var currentTimeStamp = new Date().valueOf();

                    var userAgeinGigya = (currentTimeStamp - userCreatedTimestamp)/(60*60*1000);
                    if (userAgeinGigya>24 && !isVerified) {
                        isEmailVerified = false;
                    }
                }
                return isEmailVerified;
            };

            this.getGigyaId = function() {
                var gigyaId = '';
                var profileMasterInfo = userProfileManager.getUserProfileMasterInfo();
                if (profileMasterInfo) {
                    gigyaId = profileMasterInfo.gigyaId;
                }

                return gigyaId;
            };

            this.sendUserNameVerificationEmail = function(data) {
                var eid = this.getEidDetails();
                var locale=languageCode+'_'+countryCode;
                var url=emailServiceUrl.replace('{eid}', eid).replace('{locale}', locale);
                var emailUrl = sapServiceEndPoint + url;

                var gigyaId = this.getGigyaId();
                var requestData = {
                    'messageID': 'user-email-verification-template',
                    'sendToEmail': data.sendToEmail,
                    'messageData': {
                        'gigyaId': gigyaId,
                    }
                };
                var deferred1 = $q.defer();
                $http.post(emailUrl, requestData).then(function(response) {
                    deferred1.resolve(response.data);
                });
                return deferred1.promise;
            };

            this.loadGigyaProfileDetails = function() {
                var deferred = $q.defer();
                var data = {};
                var config = {};
                var gigyaId = this.getGigyaId();

                var getUrl = $window.location.protocol+'//'+$window.location.host
                + '/mecommerce/signup/user/getusergigyaprofile?UID='+gigyaId;
                $http.post(getUrl, data, config).then(function(response) {
                    deferred.resolve(response.data);
                });
                return deferred.promise;
            };
        }]);



//////////////////
// WEBPACK FOOTER
// ./services/personal-service.js
// module id = 375
// module chunks = 0